<template>
  <Modal :show="show" maxWidth="600px" width="95%" theme="dark">
    <div class="relative pt-4 overflow-hidden bg-white rounded-lg shadow-xl">
      <div>
        <h4 class="text-xl font-semibold text-center">
          {{ isCancel ? $t('schedule.modalCancel.heading') : $t('schedule.modalConfirm.heading') }}
        </h4>
        <span
          class="absolute top-0 right-0 block p-1 mt-4 ml-auto mr-4 rounded-full cursor-pointer bg-ricoma-gray-300 text-ricoma-gray-500"
          @click="$emit('close')"
        >
          <VSvgIcon name="close" />
        </span>
      </div>
      <div class="flex flex-col items-center justify-center w-4/5 h-64 px-4 mx-auto">
        <div class="px-4 py-5 text-center rounded bg-ricoma-gray-100">
          <slot></slot>
        </div>
        <div>
          <slot name="info"></slot>
        </div>
      </div>
      <button
        @click="$emit('proceed')"
        :class="[!isCancel ? 'button max-w-full rounded-t-none' : 'bg-black']"
        class="w-full text-white text-sm py-5 uppercase"
        :disabled="loading"
      >
        <BeatLoader v-if="loading" color="#FAFAFA" :size="0.875" sizeUnit="rem" />
        <slot v-else name="button">
          {{ $t('schedule.modalCancel.btn') }}
        </slot>
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/modal/Modal';
import VSvgIcon from '@/components/base/VSvgIcon';
import { BeatLoader } from '@saeris/vue-spinners';

export default {
  name: 'ScheduleModal',
  components: { Modal, VSvgIcon, BeatLoader },
  props: { show: Boolean, isCancel: { type: Boolean, default: false }, loading: Boolean },
};
</script>
